import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from 'contexts/authContext';
import { AppContextProvider } from 'contexts/appContext';
import { ViewsContextProvider } from 'contexts/viewsContext';
import AppLoadingIndicator from './indicators/appLoadingIndicator';
import AppRoutes from './appRoutes';
import AppWrapper from './appWrapper';
import AppErrorCatcher from './errors/appErrorCatcher';

import './app.css';
import './theme/core.css';
import './theme/alert.css';
import './theme/badge.css';
import './theme/breadcrumb.css';
import './theme/button.css';
import './theme/card.css';
import './theme/dropdown.css';
import './theme/form.css';
import './theme/pagination.css';
import './theme/list.css';
import './theme/progress.css';
import './theme/table.css';
import './theme/tabs.css';
import './theme/text.css';

export default function App() {
  return (
    <BrowserRouter>
      <AppErrorCatcher>
        <AuthContextProvider>
          <AppContextProvider>
            <ViewsContextProvider>
              <AppWrapper>
                <AppRoutes />
              </AppWrapper>
            </ViewsContextProvider>
          </AppContextProvider>
        </AuthContextProvider>
      </AppErrorCatcher>
      <AppLoadingIndicator />
    </BrowserRouter>
  );
}